import firebase from 'firebase/app';
import 'firebase/firestore'

firebase.initializeApp({
    apiKey: "AIzaSyD3ruLGJ11Fa8GHauFYfDhGYja4kf9zofE",
    authDomain: "encuestas-517e6.firebaseapp.com",
    databaseURL: "https://encuestas-517e6.firebaseio.com",
    projectId: "encuestas-517e6",
    storageBucket: "encuestas-517e6.appspot.com",
    messagingSenderId: "651924043273",
    appId: "1:651924043273:web:0902a698cf4f61054caad8",
    measurementId: "G-NB6M79ENCX"
})
let db = firebase.firestore();

export default db;
